import { z } from 'zod'

const baseObject = z.object({
  email: z
    .string()
    .email({ message: 'Invalid email format.' })
    .min(10, { message: 'Email must be at least 10 characters long.' }),
  password: z
    .string()
    .min(6, { message: 'Password must be at least 6 characters long.' }),
  confirmPassword: z.string(),
})

const extendedSchema = baseObject.refine(
  data => data.password === data.confirmPassword,
  {
    message: 'Passwords do not match.',
    path: ['confirmPassword'],
  },
)

export default extendedSchema
